class AnchorNav {
    constructor() {
        this.anchorNavWrapper = document.querySelector('.anchor-nav-wrapper');
        this.header = document.querySelector('.header');
        this.viewportWidth = window.innerWidth;
        this.mainTop = this.header.offsetHeight;
        this.specialOffer = document.querySelector('.special-offer');
    }

    init() {
        this.initAnchorNav();
    }

    initAnchorNav() {
        let anchorNav = document.querySelectorAll('.anchor-nav-item a');

        anchorNav.forEach((item) => {
            item.addEventListener('click', (event) => {
                event.preventDefault();
                this.anchorNavWrapper.classList.add('sticky');

                const href = event.target.hash;
                const offset = document.querySelector(href).offsetTop - this.anchorNavWrapper.offsetHeight;

                window.scroll({
                    top: offset,
                    behavior: 'smooth'
                });
            });
        });

        if (this.anchorNavWrapper !== null) {
            window.addEventListener('scroll', () => {
                let y = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
                this.mainTop = this.header.offsetHeight;

                if (y >= this.mainTop) {
                    this.anchorNavWrapper.style.top = `${this.mainTop}px`;
                    this.anchorNavWrapper.classList.add('sticky');

                    // If present, adjust special offer
                    if (this.specialOffer !== null) {
                        if (window.innerWidth > 992) {
                            let offset = this.mainTop + this.anchorNavWrapper.offsetHeight + 20;
                            this.specialOffer.style.top = `${offset}px`;
                        }
                    }
                }
                else {
                    this.anchorNavWrapper.removeAttribute('style');
                    this.anchorNavWrapper.classList.remove('sticky');
                }
            });
        }
    }
}

export default AnchorNav;

(() => {
    const anchorNav = new AnchorNav();
    anchorNav.init();
})();